"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    en: {
        GENERIC: {
            // Will be overriden by entity errorLocalized
            label: 'Other',
        },
        MARRIED_IN_COMMUNITY_OF_PROPERTY: {
            label: 'Married in community of property',
        },
        MINOR: {
            label: 'Minor',
        },
        NO_PAPERLESS: {
            label: 'No paperless',
        },
        STUDENT_FOREIGNER: {
            label: 'Student foreigner',
        },
        UNSUPPORTED_JOB: {
            label: 'Unsupported job',
        },
    },
    fr: {
        GENERIC: {
            // Will be overriden by entity errorLocalized
            label: 'Autre',
        },
        MARRIED_IN_COMMUNITY_OF_PROPERTY: {
            label: 'Marié sous la communauté de biens',
        },
        MINOR: {
            label: 'Mineur',
        },
        NO_PAPERLESS: {
            label: 'Dossier non dématérialisé',
        },
        STUDENT_FOREIGNER: {
            label: 'Visa étudiant',
        },
        UNSUPPORTED_JOB: {
            label: 'Métier non supporté',
        },
    },
};
